import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})

export class DatepickerComponent {

    @Input() picker!: string;
    @Input() startDate?: Date;
    @Input() label = '';
    @Input() error: string | null = '';
    @Input() placeholder = '';
    @Input() control!: FormControl;
    @Input() min?: Date;
    @Input() max?: Date;
    @Input() icon:
        | ''
        | 'calender' = '';

    @ViewChild('input') public inputRef!: ElementRef;
}
